// Where the backend lives. REACT_APP_BASE_URL is the REST base (it ends in
// /api/); the socket server is on the same host unless REACT_APP_SOCKET_URL
// points elsewhere. Read on every call so tests can set process.env.
const readBaseUrl = () => {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  if (!baseUrl) {
    throw new Error('REACT_APP_BASE_URL is not set (see .env.example)');
  }
  return baseUrl;
};

export const apiUrl = (path) =>
  `${readBaseUrl().replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`;

export const socketUrl = () =>
  process.env.REACT_APP_SOCKET_URL || new URL(readBaseUrl()).origin;
